<script>
  let { nodes, width, height, query, suggestions, index = 0 } = $props()

  const highlightedGroups = $derived.by(() => {
    let groups = []

    const isSearchActive = query && query.trim() !== ''
    if (isSearchActive) {
      const trimmedQuery = query.trim().toLowerCase()
      const exactMatch = nodes.find((n) => String(n['bto-name']).toLowerCase() === trimmedQuery)
      if (exactMatch) {
        groups.push({ name: exactMatch['bto-name'], nodes: [exactMatch] })
      }
      return groups
    }

    if (index === 7) {
      const namesToHighlight = ['Hougang Capeview', 'Parc Clover @ Tengah', 'Alkaff CourtView']
      namesToHighlight.forEach((name) => {
        const matches = nodes.filter((n) => n['bto-name'] === name)
        if (matches.length > 0) {
          groups.push({ name, nodes: [matches[0]] })
        }
      })
    } else if (index === 8) {
      const namesToHighlight = ['Matilda Portico', 'Ghim Moh Natura', 'Belvia', 'The Coris']
      namesToHighlight.forEach((name) => {
        const matches = nodes.filter((n) => n['bto-name'] === name)
        if (matches.length > 0) {
          groups.push({ name, nodes: [matches[0]] })
        }
      })
    }

    return groups
  })
  const labelPositions = $derived.by(() => {
    let positions = highlightedGroups.map((g) => {
      const baseNode = g.nodes[0]
      let placeLeft = baseNode.cx > width / 2

      if (g.name === 'Belvia') {
        placeLeft = false
      } else if (g.name === 'Ghim Moh Natura') {
        placeLeft = true
      }

      return {
        name: g.name,
        nodes: g.nodes,
        baseNode,
        placeLeft,
        x: placeLeft ? baseNode.cx - 60 : baseNode.cx + 60,
        y: baseNode.cy - 25,
      }
    })

    const leftLabels = positions.filter((p) => p.placeLeft)
    const rightLabels = positions.filter((p) => !p.placeLeft)
    const MIN_DIST = 40

    function resolveOverlaps(labels) {
      labels.sort((a, b) => a.y - b.y)
      let overlapping = true
      let iterations = 0
      while (overlapping && iterations < 10) {
        overlapping = false
        for (let i = 0; i < labels.length - 1; i++) {
          const a = labels[i]
          const b = labels[i + 1]
          const diff = b.y - a.y
          if (diff < MIN_DIST) {
            overlapping = true
            const overlap = MIN_DIST - diff
            a.y -= overlap / 2
            b.y += overlap / 2
          }
        }
        labels.sort((a, b) => a.y - b.y)
        iterations++
      }
    }

    resolveOverlaps(leftLabels)
    resolveOverlaps(rightLabels)

    return [...leftLabels, ...rightLabels]
  })
</script>

<svg
  {width}
  {height}
  class="labels-svg-overlay"
  style="position: absolute; top: 0; left: 0; pointer-events: none; z-index: 10; overflow: visible;"
>
  <defs>
    <marker id="arrow-label" markerWidth="10" markerHeight="10" refX="7" refY="5" orient="auto">
      <polyline
        points="3 2, 7 5, 3 8"
        fill="none"
        stroke="#fff"
        stroke-width="1"
        stroke-linejoin="miter"
        stroke-linecap="butt"
      />
    </marker>
  </defs>
  <g transform="translate(0, 50)">
    {#each labelPositions as pos (pos.name)}
      {#each pos.nodes as node (node.id)}
        {#if pos.placeLeft}
          <path
            d="M {pos.x} {pos.y} Q {pos.baseNode.cx - 20} {pos.y} {node.cx - 2} {node.cy - 2}"
            fill="none"
            stroke="#fff"
            stroke-width="1"
            marker-end="url(#arrow-label)"
          />
        {:else}
          <path
            d="M {pos.x} {pos.y} Q {pos.baseNode.cx + 20} {pos.y} {node.cx + 2} {node.cy - 2}"
            fill="none"
            stroke="#fff"
            stroke-width="1"
            marker-end="url(#arrow-label)"
          />
        {/if}
      {/each}
    {/each}
  </g>
</svg>

{#each labelPositions as pos (pos.name)}
  <div
    class="highlight-label"
    class:place-left={pos.placeLeft}
    style="left: {pos.placeLeft ? pos.x - 5 : pos.x + 5}px; top: {pos.y + 50 - 10}px;"
  >
    {pos.name}
  </div>
{/each}

<style lang="scss">
  .labels-svg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 10;
  }

  .highlight-label {
    position: absolute;
    // background: rgba(30, 40, 80, 0.8);
    background: rgba(20, 44, 126, 0.8);
    color: white;
    padding: 5px 6px 3px 6px;
    border-radius: 4px;
    font-size: 14px;
    pointer-events: none;
    max-width: 120px;
    text-align: center;
    line-height: 1.2;
    z-index: 11;
    transition: transform 0.1s ease;
    font-family: CuratorLight;

    @media (min-width: 744px) {
      white-space: nowrap;
      max-width: none;
    }

    &.place-left {
      transform: translateX(-100%);
    }
  }
</style>
